import { SpendLimitActionType } from "../Constants/SpendLimitActionType";

export const setSpendLimit = spendLimit => {
	return {
		type: SpendLimitActionType.SET_SPEND_LIMIT,
		payload: spendLimit,
	};
};
